<script setup lang="ts">
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
defineExpose({
  name: 'PaginationItem',
});

interface Props {
  href?: string;
  num?: number;
  isActive?: boolean;
  isOmission?: boolean;
  isPrev?: boolean;
  isNext?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  href: '',
  num: 1,
  isActive: false,
  isOmission: false,
  isPrev: false,
  isNext: false,
});
</script>

<template>
  <span
    v-if="isActive || isOmission"
    class="PaginationItem"
    :class="[
      {
        'PaginationItem--active': isActive,
        'PaginationItem--omission': isOmission,
      },
    ]"
  >
    <span v-if="!isOmission && num" class="PaginationItem__num">{{ num }}</span>
    <span v-if="isOmission" class="PaginationItem__omission">…</span>
  </span>

  <router-link
    v-else
    class="PaginationItem"
    :to="props.href"
    :href="href"
    :aria-label="isPrev ? '前へ' : isNext ? '次へ' : ''"
    :role="[isPrev || isNext ? 'link' : '']"
  >
    <span v-if="!isPrev && !isNext && num" class="PaginationItem__num">{{
      num
    }}</span>
    <Icon
      v-if="isPrev || isNext"
      class="PaginationItem__icon"
      :iconName="isPrev ? 'Left' : isNext ? 'Right' : ''"
    />
  </router-link>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.PaginationItem {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: $service-unit * 9;
  height: $service-unit * 9;
  font-size: $service-font-size-mp;
  color: $color-gray-80;
  background-color: $color-white-100;
  border: 1px solid $color-gray-50;
  border-radius: $service-border-radius;

  &:hover:not(&--active) {
    text-decoration: none;
    background-color: $color-gray-20;
  }

  &--active {
    color: $color-white-100;
    background-color: $color-blue-60;
    border: none;
  }

  &--omission {
    pointer-events: none;
    border: none;

    &:hover {
      cursor: default;
      background-color: transparent;
    }
  }

  & &__icon {
    width: $service-unit * 6;
    height: $service-unit * 6;
  }
}
</style>
